var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import debug from 'debug';
import { EventEmitter } from './EventEmitter';
import { isReady } from './isReady';
import { newid } from './newid';
var HEARTBEAT = JSON.stringify({ type: 'Heartbeat' });
/**
 * This is a client for `relay` that keeps track of all peers that the server connects you to, and
 * for each peer it keeps track of each documentId (aka discoveryKey, aka channel) that you're
 * working with that peer on.
 *
 * The peers are WebSocket instances
 *
 * The simplest workflow is something like this:
 *
 * ```ts
 * client = new Client({ userName: 'my-peer-userName', url })
 *   .join('my-document-userName')
 *   .on('peer.connect', ({documentId, userName, socket}) => {
 *     // send a message
 *     socket.send('Hello!')
 *
 *     // listen for messages
 *     socket.onmessage = (e) => {
 *       const { data } = e
 *       console.log(data)
 *     }
 *   })
 * ```
 */
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    /**
     * @param userName a string that identifies you uniquely, defaults to a UUID
     * @param url the url of the `relay`, e.g. `http://myrelay.mydomain.com`
     * @param documentIds one or more document IDs that you're interested in
     */
    function Client(_a) {
        var _b = _a.userName, userName = _b === void 0 ? newid() : _b, url = _a.url, _c = _a.documentIds, documentIds = _c === void 0 ? [] : _c, _d = _a.minRetryDelay, minRetryDelay = _d === void 0 ? 10 : _d, _e = _a.backoffFactor, backoffFactor = _e === void 0 ? 1.5 : _e, _f = _a.maxRetryDelay, maxRetryDelay = _f === void 0 ? 30000 : _f;
        var _this = _super.call(this) || this;
        /** All the document IDs we're interested in */
        _this.documentIds = new Set();
        /** All the peers we're connected to. (A 'peer' in this case is actually just a bunch of sockets -
         * one per documentId that we have in common.) */
        _this.peers = new Map();
        _this.serverConnectionQueue = [];
        _this.log = debug("lf:relay:client:" + userName);
        _this.userName = userName;
        _this.url = url;
        _this.minRetryDelay = minRetryDelay;
        _this.maxRetryDelay = maxRetryDelay;
        _this.backoffFactor = backoffFactor;
        // start out at the initial retry delay
        _this.retryDelay = minRetryDelay;
        _this.connectToServer();
        documentIds.forEach(function (id) { return _this.join(id); });
        return _this;
    }
    /**
     * Connects to the relay server, lets it know what documents we're interested in
     * @param documentIds array of IDs of documents we're interested in
     * @returns the socket connecting us to the server
     */
    Client.prototype.connectToServer = function () {
        var _this = this;
        var url = this.url + "/introduction/" + this.userName;
        this.log('connecting to relay server', url);
        var socket = new WebSocket(url);
        socket.onopen = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isReady(socket)];
                    case 1:
                        _a.sent();
                        this.retryDelay = this.minRetryDelay;
                        this.drainQueue();
                        this.emit('server.connect');
                        this.open = true;
                        this.heartbeat = setInterval(function () { return socket.send(HEARTBEAT); }, 5000);
                        return [2 /*return*/];
                }
            });
        }); };
        socket.onmessage = function (messageEvent) {
            var data = messageEvent.data;
            var message = JSON.parse(data.toString());
            // The only kind of message that we receive from the relay server is an introduction, which tells
            // us that someone else is interested in the same thing we are.
            if (message.type !== 'Introduction')
                throw new Error("Invalid message type '" + message.type + "'");
            // When we receive that message, we respond by requesting a "direct" connection to the peer
            // (via piped sockets on the relay server) for each document ID that we have in common
            var connectToPeer = function (documentId, userName) {
                var peer = _this.get(userName);
                if (peer.has(documentId))
                    return; // don't add twice
                var url = _this.url + "/connection/" + _this.userName + "/" + userName + "/" + documentId;
                var socket = new WebSocket(url);
                socket.onopen = function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: 
                            // make sure the socket is actually in READY state
                            return [4 /*yield*/, isReady(socket)
                                // add the socket to the map for this peer
                            ];
                            case 1:
                                // make sure the socket is actually in READY state
                                _a.sent();
                                // add the socket to the map for this peer
                                peer.set(documentId, socket);
                                this.emit('peer.connect', { userName: userName, documentId: documentId, socket: socket });
                                return [2 /*return*/];
                        }
                    });
                }); };
                // if the other end disconnects, we disconnect
                socket.onclose = function () {
                    _this.closeSocket(userName, documentId);
                    _this.emit('peer.disconnect', { userName: userName, documentId: documentId, socket: socket });
                };
            };
            var userName = message.userName, _a = message.documentIds, documentIds = _a === void 0 ? [] : _a;
            documentIds.forEach(function (documentId) { return connectToPeer(documentId, userName); });
        };
        socket.onclose = function () {
            _this.open = false;
            _this.emit('server.disconnect');
            // stop heartbeat
            clearInterval(_this.heartbeat);
            // try to reconnect after a delay
            setTimeout(function () {
                _this.connectToServer();
                _this.documentIds.forEach(function (id) { return _this.join(id); });
            }, _this.retryDelay);
            // increase the delay for next time
            if (_this.retryDelay < _this.maxRetryDelay)
                _this.retryDelay *= _this.backoffFactor + Math.random() * 0.1 - 0.05; // randomly vary the delay
            _this.log("Relay connection closed. Retrying in " + Math.floor(_this.retryDelay / 1000) + "s");
        };
        socket.onerror = function (ev) {
            _this.emit('error', ev);
        };
        this.serverConnection = socket;
        return this.serverConnection;
    };
    /**
     * Lets the server know that you're interested in a document. If there are other peers who have
     * joined the same DocumentId, you and the remote peer will both receive an introduction message,
     * inviting you to connect.
     * @param documentId
     */
    Client.prototype.join = function (documentId) {
        this.log('joining', documentId);
        this.documentIds.add(documentId);
        var message = { type: 'Join', documentIds: [documentId] };
        this.send(message);
        return this;
    };
    /**
     * Leaves a documentId and closes any connections related to it
     * @param documentId
     */
    Client.prototype.leave = function (documentId) {
        var e_1, _a;
        this.log('leaving', documentId);
        this.documentIds.delete(documentId);
        try {
            for (var _b = __values(this.peers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 1), userName = _d[0];
                this.closeSocket(userName, documentId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var message = { type: 'Leave', documentIds: [documentId] };
        this.send(message);
        return this;
    };
    /**
     * Disconnects from one peer
     * @param peerUserName Name of the peer to disconnect. If none is provided, we disconnect all peers.
     */
    Client.prototype.disconnectPeer = function (peerUserName) {
        var e_2, _a;
        this.log("disconnecting from " + peerUserName);
        var peer = this.get(peerUserName);
        try {
            for (var peer_1 = __values(peer), peer_1_1 = peer_1.next(); !peer_1_1.done; peer_1_1 = peer_1.next()) {
                var _b = __read(peer_1_1.value, 1), documentId = _b[0];
                this.closeSocket(peerUserName, documentId);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (peer_1_1 && !peer_1_1.done && (_a = peer_1.return)) _a.call(peer_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return this;
    };
    /**
     * Disconnects from all peers and from the relay server
     */
    Client.prototype.disconnectServer = function () {
        var e_3, _a;
        this.log("disconnecting from all peers'}");
        var peersToDisconnect = Array.from(this.peers.keys()); // all of them
        try {
            for (var peersToDisconnect_1 = __values(peersToDisconnect), peersToDisconnect_1_1 = peersToDisconnect_1.next(); !peersToDisconnect_1_1.done; peersToDisconnect_1_1 = peersToDisconnect_1.next()) {
                var userName = peersToDisconnect_1_1.value;
                this.disconnectPeer(userName);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (peersToDisconnect_1_1 && !peersToDisconnect_1_1.done && (_a = peersToDisconnect_1.return)) _a.call(peersToDisconnect_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.removeAllListeners();
        this.serverConnection.close();
    };
    Client.prototype.has = function (peerUserName, documentId) {
        if (documentId !== undefined) {
            return this.has(peerUserName) && this.peers.get(peerUserName).has(documentId);
        }
        else {
            return this.peers.has(peerUserName);
        }
    };
    Client.prototype.get = function (peerUserName, documentId) {
        var _a;
        if (documentId !== undefined) {
            return (_a = this.get(peerUserName)) === null || _a === void 0 ? void 0 : _a.get(documentId);
        }
        else {
            // create an entry for this peer if there isn't already one
            if (!this.has(peerUserName))
                this.peers.set(peerUserName, new Map());
            return this.peers.get(peerUserName);
        }
    };
    Client.prototype.drainQueue = function () {
        while (this.serverConnectionQueue.length) {
            var message = this.serverConnectionQueue.pop();
            this.send(message);
        }
    };
    Client.prototype.send = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isReady(this.serverConnection)];
                    case 1:
                        _a.sent();
                        try {
                            this.serverConnection.send(JSON.stringify(message));
                        }
                        catch (err) {
                            this.serverConnectionQueue.push(message);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.closeSocket = function (userName, documentId) {
        var peer = this.get(userName);
        if (peer.has(documentId)) {
            var socket = peer.get(documentId);
            if (socket && socket.readyState !== socket.CLOSED && socket.readyState !== socket.CLOSING)
                socket.close();
            peer.delete(documentId);
        }
    };
    return Client;
}(EventEmitter));
export { Client };
//# sourceMappingURL=Client.js.map